/***
 * @file:
 * @author: caojianping
 * @Date: 2021-05-24 16:42:23
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzMenuModule } from 'ng-zorro-antd/menu';

import { DtBrowserModule } from '@ithinkdt/shared/browser';

import { HeaderI18nComponent } from './i18n.component';

const ANGULAR_MODULES = [CommonModule];

const THIRD_MODULES = [TranslateModule];

const ANTD_MODULES = [NzDropDownModule, NzIconModule, NzMenuModule];

const COMPONENTS = [HeaderI18nComponent];

@NgModule({
  imports: [...ANGULAR_MODULES, ...THIRD_MODULES, ...ANTD_MODULES, DtBrowserModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class DtI18nModule {}
